<script>
  import ButtonSmall from '../ButtonSmall.svelte';
  import StandingTeam from './StandingTeam.svelte';
  import Common from '../../js/common.js';

  export let value;
  export let lang = undefined;
</script>

<div class='standing-prepend'>
  <div class='standing-prepend-position'>
    <ButtonSmall value={Common.addZeros(value.position)}/>
  </div>

  <div class='standing-prepend-team'>
    <StandingTeam {value} bind:lang/>
  </div>
</div>

<style>
  .standing-prepend {
    display: flex;
    gap: 20px;
  }
</style>
